window.addEventListener('DOMContentLoaded', ()=>{

    let popup = document.getElementById('consent-popup');
    const cookieName = 'cookieconsent';

    if(popup){

        setTimeout( () => {

            if( false == isCookieValid() ){
                // Fadein popup
                popup.style.opacity = 0;
                popup.style.display = "grid";
                setTimeout( () => popup.style.opacity = 1, 100 );
            }else{
                popup.style.display = "none";
            }
    
            let buttons = popup.querySelectorAll('.submit-button');
            Array.from(buttons).forEach( button => button.addEventListener('click', handleCookieSubmit ) )

        } , 3000 );

    }

    /**
     * Save cookie & fadeout popup
     */
    function handleCookieSubmit(e){
        let value = e.target.value;
        let threeMonths = 90 * 24 * 60 * 60 * 1000;
        saveCookie( cookieName, value, threeMonths );
        setTimeout( () => popup.style.opacity = 0, 200 );
        setTimeout( () => popup.style.display = "none", 800 );
    }

    /**
     * Check cookie exists & has expired
     */
    function isCookieValid(){
        const saved = localStorage.getItem(cookieName);
        if (!saved) return false;

        try {
            const data = JSON.parse(saved);
            const now = new Date().getTime();

            if (now >= data.expiry) {
                localStorage.removeItem(cookieName);
                return false;
            }

            return true;
        } catch {
            localStorage.removeItem(cookieName);
            return false;
        }

    }

    /**
     * Save cookie
     */
    function saveCookie( name, value, expireTime ){
        const expiry = new Date().getTime() + expireTime;
        localStorage.setItem(name, JSON.stringify({ accepted: value, expiry }));
    }

})